/**
 * Shared branding assets and labels for Rasmus surfaces.
 */
export const RASMUS_BRANDING = {
  logo: {
    primary: 'assets/img/rasmus-logo-primary.svg',
    mark: 'assets/img/rasmus-logo-mark.svg',
    ariaLabel: 'Rasmus Auctions logo',
  },
} as const;
